import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './profileLinks.scss';

class ProfileLinks extends Component {
  static propTypes = {
    config: PropTypes.object.isRequired
  }

  createLinks() {
    const { profileLinks } = this.props.config;
    return profileLinks.map(item => (
      <li key={item.name} className={`profile-${item.name}`}>
        <a href={item.url} target="_blank" rel="noopener noreferrer">
          <i className={item.iconClass} />
        </a>
      </li>
    ));
  }

  render() {
    return (
      <ul className="profile-links">{this.createLinks()}</ul>
    )
  }
}

export default ProfileLinks;



// WEBPACK FOOTER //
// ./src/components/ProfileLinks/ProfileLinks.jsx